import { instance as axios, setJwtToken } from "../../config/axiosInstance";

const BASE = "/admin/v1/influencers";

// ── CRUD ──────────────────────────────────────────────────────────────────────
export const fetchInfluencersApi = async (params = {}) => {
  const query = new URLSearchParams({ ...params }).toString();
  return await axios.get(`${BASE}?${query}`, setJwtToken());
};

export const fetchInfluencerByIdApi = async (id) => {
  return await axios.get(`${BASE}/${id}`, setJwtToken());
};

export const createInfluencerApi = async (data) => {
  return await axios.post(BASE, data, setJwtToken());
};

export const updateInfluencerApi = async (id, data) => {
  return await axios.put(`${BASE}/${id}`, data, setJwtToken());
};

export const deleteInfluencerApi = async (id) => {
  return await axios.delete(`${BASE}/${id}`, setJwtToken());
};

// ── Metrics ───────────────────────────────────────────────────────────────────
export const fetchInfluencerMetricsApi = async (id, params = {}) => {
  const query = new URLSearchParams({ ...params }).toString();
  return await axios.get(`${BASE}/${id}/metrics?${query}`, setJwtToken());
};

// ── Ledger ────────────────────────────────────────────────────────────────────
export const fetchInfluencerLedgerApi = async (id, params = {}) => {
  const query = new URLSearchParams({ ...params }).toString();
  return await axios.get(`${BASE}/${id}/ledger?${query}`, setJwtToken());
};

// ── Settlements ───────────────────────────────────────────────────────────────
export const fetchInfluencerSettlementsApi = async (id, params = {}) => {
  const query = new URLSearchParams({ ...params }).toString();
  return await axios.get(`${BASE}/${id}/settlements?${query}`, setJwtToken());
};

export const fetchSettlementPreviewApi = async (id, periodStart, periodEnd) => {
  const query = new URLSearchParams({ periodStart, periodEnd }).toString();
  return await axios.get(`${BASE}/${id}/settlement-preview?${query}`, setJwtToken());
};

export const createSettlementApi = async (id, data) => {
  return await axios.post(`${BASE}/${id}/settle`, data, setJwtToken());
};

export const exportInfluencerEarningsApi = async (params = {}) => {
  const query = new URLSearchParams(
    Object.fromEntries(Object.entries(params).filter(([, v]) => v != null && v !== ''))
  ).toString();
  return await axios.get(`${BASE}/earnings/export?${query}`, {
    ...setJwtToken(),
    responseType: 'blob',
  });
};
